import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import ChartCard from '../components/Dashboard/ChartCard';
import InsightCard from '../components/Analytics/InsightCard';
import { mockFinancialData, mockFinancialInsights } from '../data/mockData';

const AnalyticsPage: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Financial Analytics
      </Typography>
      
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} md={6}>
          <ChartCard 
            title="Revenue Trends (Monthly)" 
            chartType="line" 
            data={mockFinancialData.revenue} 
            height={350}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <ChartCard 
            title="Cash Flow Forecast" 
            chartType="line" 
            data={mockFinancialData.cashFlowForecast} 
            height={350}
          />
        </Grid>
      </Grid>
      
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} md={6}>
          <ChartCard 
            title="Expenses by Category" 
            chartType="pie" 
            data={mockFinancialData.expenses} 
            height={350}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <ChartCard 
            title="Profit Margins by Product" 
            chartType="bar" 
            data={mockFinancialData.profitMargins} 
            height={350}
          />
        </Grid>
      </Grid>
      
      <Typography variant="h5" sx={{ mb: 2, mt: 4 }}>
        AI-Generated Insights
      </Typography>
      
      <Grid container spacing={3}>
        {mockFinancialInsights.map((insight) => (
          <Grid item xs={12} md={6} lg={4} key={insight.id}>
            <InsightCard 
              title={insight.title} 
              description={insight.description} 
              impact={insight.impact as 'High' | 'Medium' | 'Low'} 
              category={insight.category} 
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default AnalyticsPage;
